// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ibAO","file":"styles_file__1vhvs"};